import Coefficients from '@/components/report/Coefficients.vue'
import Parameters from '@/components/report/Parameters.vue'
import PriceSummary from '@/components/report/PriceSummary.vue'
import MarketComparison from '@/components/report/MarketComparison.vue'
import MarketSummary from '@/components/report/MarketSummary.vue'
import UnitInformation from '@/components/report/UnitInformation.vue'
import OtherSpecification from '@/components/report/OtherSpecification.vue'
import CuttedPrices from '@/components/report/CuttedPrices.vue'
import AdvertisingTransactions from '@/components/report/AdvertisingTransactions.vue'

export {
  Coefficients,
  Parameters,
  PriceSummary,
  MarketComparison,
  MarketSummary,
  UnitInformation,
  OtherSpecification,
  CuttedPrices,
  AdvertisingTransactions,
}
